wbApp.controller('PaymentsSalesRepotParamsCtrl', ['$scope', '$window', 'terminalSvc',
function ($scope, $window, terminalSvc) {

    $scope.terminalSetting = terminalSvc.getTerminalSetting();

    $scope.model = {
        startDate: moment().toDate(),
        endDate: moment().toDate(),
        paymentTypeID: 1, // Cash
        terminalID: null
    };

    $scope.terminalSetting.$promise.then(function (s) {
        $scope.model.terminalID = s.terminalID;
    });


    $scope.onDetailSave = function () {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        var fromDate = moment($scope.model.startDate).startOf('day').toDate();
        var toDate = moment($scope.model.endDate).endOf('day').toDate();

        $scope.$hide();

        var terminalIDparam = !!$scope.model.terminalID ? '&terminalID=' + $scope.model.terminalID : '';

        $window.open('/Admin/Report/Sales' + 
            '?startDate=' + fromDate.toJSON() + 
            '&endDate=' + toDate.toJSON() + 
            terminalIDparam +
            '&paymentTypeID=' + $scope.model.paymentTypeID,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

}]);
